import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  Chip,
} from "@material-ui/core";

const AdminVipSeatSelector = ({ totalSeats, existingVipGroups, onChange }) => {
  const [vipType, setVipType] = useState("couple");
  const seatCount = vipType === "couple" ? 3 : 6;

  const allVipSeats = existingVipGroups.flatMap((g) => g.seats);
  const findGroupBySeat = (seatNo) =>
    existingVipGroups.find((g) => g.seats.includes(seatNo));

  const handleSeatClick = (seatNo) => {
    const existingGroup = findGroupBySeat(seatNo);

    // REMOVE VIP GROUP
    if (existingGroup) {
      onChange(existingVipGroups.filter((g) => g !== existingGroup));
      return;
    }

    // ADD VIP GROUP
    const newSeats = Array.from({ length: seatCount }, (_, i) => seatNo + i);

    if (newSeats[newSeats.length - 1] > totalSeats) {
      alert("Seats exceed bogie limit");
      return;
    }

    if (newSeats.some((s) => allVipSeats.includes(s))) {
      alert("Seat already part of another VIP group");
      return;
    }

    onChange([...existingVipGroups, { type: vipType, seats: newSeats }]);
  };

  /* -------------------------------
   Seat Grid Calculation
   FIXED 3 ROWS, DYNAMIC COLUMNS
-------------------------------- */
  const rows = 3; // ✅ ALWAYS 3
  const cols = Math.ceil(totalSeats / rows);
  const seatGrid = [];

  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const seatNo = col * rows + row + 1;
      if (seatNo <= totalSeats) {
        seatGrid.push({ seatNo });
      }
    }
  }

  /* -------------------------------
     Render
  -------------------------------- */
  return (
    <Box mt={2}>
      <Typography variant="subtitle1">VIP Type</Typography>

      <Select
        fullWidth
        value={vipType}
        onChange={(e) => setVipType(e.target.value)}
      >
        <MenuItem value="couple">Couple (3 seats)</MenuItem>
        <MenuItem value="family">Family (6 seats)</MenuItem>
      </Select>

      <Box mt={3}>
        <Typography variant="subtitle2" gutterBottom>
          Select starting seat
        </Typography>

        <Box
          display="grid"
          gridTemplateColumns={`repeat(${cols}, 44px)`} 
          columnGap={10}
          rowGap={10}
        >
          {seatGrid.map(({ seatNo }) => {
            const vipGroup = findGroupBySeat(seatNo);
            const type = vipGroup?.type;

            return (
              <Button
                key={seatNo}
                onClick={() => handleSeatClick(seatNo)}
                variant="outlined"
                style={{
                  width: 40,
                  height: 40,
                  minWidth: 40,
                  fontSize: 12,
                  margin: 3,
                  backgroundColor:
                    type === "couple"
                      ? "#E3F2FD"
                      : type === "family"
                      ? "#F3E5F5"
                      : "#fff",
                  border:
                    type === "couple"
                      ? "2px solid #1976D2"
                      : type === "family"
                      ? "2px solid #9C27B0"
                      : "1px solid #ccc",
                  color:
                    type === "couple"
                      ? "#1976D2"
                      : type === "family"
                      ? "#9C27B0"
                      : "#333",
                }}
              >
                {seatNo}
              </Button>
            );
          })}
        </Box>
      </Box>

      <Box mt={3}>
        <Typography variant="subtitle2">Selected VIP Groups</Typography>
        {existingVipGroups.map((g, i) => (
          <Chip
            key={i}
            label={`${g.type.toUpperCase()} → ${g.seats.join(", ")}`}
            color={g.type === "family" ? "secondary" : "primary"}
            style={{ marginRight: 8, marginBottom: 8 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default AdminVipSeatSelector;
